module.exports = __webpack_public_path__ + "img/ic_arrow_down.c292afb7.svg";